<template>
  <div id="app">
    <router-view>Home</router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
#app ::-webkit-scrollbar {
  display:none
}
</style>